// Product recommendations & Recently viewed tabs functionality
document.addEventListener('DOMContentLoaded', function() {
  const tabsSections = document.querySelectorAll('[data-section-type="related-products"]');
  
  tabsSections.forEach(section => {
    const tabsContainer = section.querySelector('.custom-tabs-header');
    if (!tabsContainer) return;

    const tabTitles = tabsContainer.querySelectorAll('.custom-tab-title');
    const tabPanels = section.querySelectorAll('[role="tabpanel"]');
    
    // Cache panel lookup
    const panelMap = new Map();
    tabPanels.forEach(panel => {
      panelMap.set(panel.id, panel);
    });

    // Force load product recommendations immediately
    function initializeProductRecommendations() {
      const productRecommendations = section.querySelectorAll('product-recommendations');
      productRecommendations.forEach(element => {
        // Force the element to load by temporarily making it visible
        const originalDisplay = element.style.display;
        const originalVisibility = element.style.visibility;
        
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        
        // Trigger the load
        if (element.load && typeof element.load === 'function') {
          element.load();
        } else {
          // Fallback: dispatch intersection event to trigger loading
          const event = new Event('intersect');
          element.dispatchEvent(event);
        }
        
        // Restore original styles after a brief delay
        setTimeout(() => {
          element.style.display = originalDisplay;
          element.style.visibility = originalVisibility;
        }, 50);
      });
    }

    function switchTab(activeTitle) {
      const targetPanelId = activeTitle.getAttribute('aria-controls');
      const targetPanel = panelMap.get(targetPanelId);
      
      if (!targetPanel) return;

      requestAnimationFrame(() => {
        // Remove active states
        tabTitles.forEach(t => t.classList.remove('active'));
        tabPanels.forEach(panel => {
          panel.hidden = true;
          panel.classList.remove('current');
        });

        // Set active states
        activeTitle.classList.add('active');
        targetPanel.hidden = false;
        targetPanel.classList.add('current');
      });
    }

    // Event delegation
    tabsContainer.addEventListener('click', function(e) {
      const clickedTab = e.target.closest('.custom-tab-title');
      if (clickedTab) {
        switchTab(clickedTab);
      }
    });

    tabsContainer.addEventListener('keydown', function(e) {
      const focusedTab = e.target.closest('.custom-tab-title');
      if (focusedTab && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        switchTab(focusedTab);
      }
    });

    // Initialize
    const activeTab = tabsContainer.querySelector('.custom-tab-title.active');
    if (!activeTab && tabTitles.length > 0) {
      switchTab(tabTitles[0]);
    }

    // Force load product recommendations after a short delay
    setTimeout(initializeProductRecommendations, 100);
  });
});

/**
 * Tabbed Sections Initializer
 * Uses the theme's existing TabsElement class
 */
class TabbedSectionsInitializer {
  constructor() {
    this.init();
    this.bindEvents();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initAllTabbedSections();
      });
    } else {
      this.initAllTabbedSections();
    }

    window.addEventListener('load', () => {
      setTimeout(() => this.initAllTabbedSections(), 100);
    });
  }

  bindEvents() {
    document.addEventListener("shopify:section:load", (event) => {
      setTimeout(() => this.initSectionTabs(event.target), 50);
    });

    document.addEventListener("shopify:section:select", (event) => {
      setTimeout(() => this.initSectionTabs(event.target), 50);
    });
  }

  initAllTabbedSections() {
    console.log("🔍 Initializing theme tabs...");
    
    const tabsElements = document.querySelectorAll('tabs-element');
    
    console.log(`Found ${tabsElements.length} tabs-element(s)`);
    
    tabsElements.forEach((tabsElement, index) => {
      this.initTabsElement(tabsElement, index);
    });
  }

  initSectionTabs(section) {
    const tabsElements = section.querySelectorAll('tabs-element');
    tabsElements.forEach((tabsElement, index) => {
      this.initTabsElement(tabsElement, index);
    });
  }

  initTabsElement(tabsElement, index) {
    const section = tabsElement.closest('[id^="shopify-section-"]');
    const sectionId = section ? section.id : `unknown-${index}`;
    
    console.log(`Initializing tabs for: ${sectionId}`);

    if (!tabsElement.hasAttribute('selected-index')) {
      tabsElement.setAttribute('selected-index', '0');
    }

    const buttons = tabsElement.querySelectorAll('button[role="tab"]');
    const selectedIndex = parseInt(tabsElement.getAttribute('selected-index')) || 0;

    this.updateTabStates(tabsElement, selectedIndex);

    // Initialize any special components in active panel
    const activePanel = tabsElement.querySelector(`#${buttons[selectedIndex]?.getAttribute('aria-controls')}`);
    if (activePanel) {
      this.initPanelComponents(activePanel);
    }

    // Add custom event listener for tab changes
    this.addTabChangeListener(tabsElement);

    console.log(`✅ Tabs initialized for: ${sectionId}`);
  }

  // Updated method using button-active class
// Updated updateTabStates method in TabbedSectionsInitializer
updateTabStates(tabsElement, selectedIndex) {
  const buttons = tabsElement.querySelectorAll('button[role="tab"]');
  
  buttons.forEach((button, buttonIndex) => {
    const panelId = button.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    
    if (panel) {
      // Update panel visibility
      if (buttonIndex === selectedIndex) {
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add('current'); // Add current class if your theme uses it
      } else {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.remove('current');
      }
      
      // Update button states with simple class-based styling
      if (buttonIndex === selectedIndex) {
        // Active tab
        button.classList.add('button-active');
        button.disabled = true;
        button.setAttribute('aria-selected', 'true');
      } else {
        // Inactive tab
        button.classList.remove('button-active');
        button.disabled = false;
        button.setAttribute('aria-selected', 'false');
      }
    }
  });
  
  // Also handle data-tab-position panels for anchor functionality
  const section = tabsElement.closest('[id^="shopify-section-"]') || tabsElement.closest('#custom_content');
  if (section) {
    const positionPanels = section.querySelectorAll('[data-tab-position]');
    positionPanels.forEach((panel, index) => {
      if (index === selectedIndex) {
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

  addTabChangeListener(tabsElement) {
    // Listen for attribute changes to detect tab switches
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'selected-index') {
          const newIndex = parseInt(tabsElement.getAttribute('selected-index'));
          
          // Apply styling when tab changes
          this.updateTabStates(tabsElement, newIndex);
          
          const buttons = tabsElement.querySelectorAll('button[role="tab"]');
          const activeButton = buttons[newIndex];
          
          if (activeButton) {
            const panelId = activeButton.getAttribute('aria-controls');
            const activePanel = document.getElementById(panelId);
            
            if (activePanel) {
              // Initialize components in the newly active panel
              setTimeout(() => {
                this.initPanelComponents(activePanel);
              }, 200);
            }
          }
        }
      });
    });

    observer.observe(tabsElement, {
      attributes: true,
      attributeFilter: ['selected-index']
    });

    // Store observer for cleanup if needed
    tabsElement._tabObserver = observer;
  }

  initPanelComponents(panel) {
    if (!panel) return;

    // Initialize image comparison components (let theme handle them)
    const imageComparisons = panel.querySelectorAll('image-comparison');
    imageComparisons.forEach((comp) => {
      // Trigger theme's image comparison initialization
      if (comp.init && typeof comp.init === 'function') {
        comp.init();
      }
      // Trigger animation after a delay
      if (comp.animate && typeof comp.animate === 'function') {
        setTimeout(() => comp.animate(), 500);
      }
    });

    // Initialize lazy images
    const lazyImages = panel.querySelectorAll('img[is="lazy-image"]');
    lazyImages.forEach((img) => {
      if (typeof window.initLazyImage === "function") {
        window.initLazyImage(img);
      }
    });

    // Initialize videos
    const videos = panel.querySelectorAll('video');
    videos.forEach((video) => {
      if (video.hasAttribute('autoplay') || video.autoplay) {
        video.muted = true;
        video.play().catch(() => {
          console.log("Video autoplay failed");
        });
      }
    });

    // Initialize any motion lists
    const motionLists = panel.querySelectorAll('motion-list');
    motionLists.forEach((list) => {
      if (list.load && typeof list.load === 'function') {
        list.load();
      }
    });

    // Trigger resize for responsive components
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  // Public methods
  switchToTab(sectionSelector, tabIndex) {
    const section = document.querySelector(sectionSelector);
    if (!section) return;

    const tabsElement = section.querySelector('tabs-element');
    if (tabsElement) {
      tabsElement.setAttribute('selected-index', tabIndex.toString());
    }
  }

  getActiveTab(sectionSelector) {
    const section = document.querySelector(sectionSelector);
    if (!section) return null;

    const tabsElement = section.querySelector('tabs-element');
    if (!tabsElement) return null;

    const selectedIndex = parseInt(tabsElement.getAttribute('selected-index')) || 0;
    const buttons = tabsElement.querySelectorAll('button[role="tab"]');
    const activeButton = buttons[selectedIndex];
    const activePanel = activeButton ? document.getElementById(activeButton.getAttribute('aria-controls')) : null;

    return {
      button: activeButton,
      panel: activePanel,
      index: selectedIndex
    };
  }
}


// Tab anchoring functionality
function initTabAnchoring() {
  let lastProcessedHash = '';
  let isProcessingHash = false;

  function openTabByPosition() {
    const hash = window.location.hash;
    
    // Only process tab hashes
    if (!hash.match(/#tab-(\d+)/)) {
      return;
    }
    
    // Prevent processing the same hash multiple times
    if (hash === lastProcessedHash || isProcessingHash) {
      return;
    }
    
    const match = hash.match(/#tab-(\d+)/);
    
    if (match) {
      isProcessingHash = true;
      lastProcessedHash = hash;
      
      const position = match[1];
      const tabIndex = parseInt(position) - 1;

      // Find the target tab panel
      const tabPanel = document.querySelector(`[data-tab-position="${position}"]`);
      
      if (tabPanel) {
        const tabContainer = tabPanel.closest("#custom_content");
        
        if (tabContainer) {
          // Use the TabbedSectionsInitializer to switch tabs properly
          const tabsElement = tabContainer.querySelector('tabs-element');
          if (tabsElement) {
            // Ensure the tab switch happens
            tabsElement.setAttribute('selected-index', tabIndex.toString());
            
            // Double-check that the panel is visible after a short delay
            setTimeout(() => {
              const targetPanel = document.querySelector(`[data-tab-position="${position}"]`);
              if (targetPanel && targetPanel.hidden) {
                targetPanel.hidden = false;
                targetPanel.setAttribute('aria-hidden', 'false');
              }
            }, 50);
          }

          // Scroll after tab switch
          setTimeout(() => {
            tabContainer.scrollIntoView({ 
              behavior: "smooth",
              block: "start"
            });
            
            setTimeout(() => {
              isProcessingHash = false;
            }, 1000);
          }, 150);
        }
      } else {
        isProcessingHash = false;
      }
    }
  }

  // Only run on initial page load if hash matches tab pattern
  if (window.location.hash.match(/#tab-(\d+)/)) {
    // Wait for TabbedSectionsInitializer to be ready
    setTimeout(() => {
      openTabByPosition();
    }, 200);
  }

  // Listen for hash changes
  window.addEventListener("hashchange", (e) => {
    // Only process if the hash actually changed and matches tab pattern
    if (e.newURL !== e.oldURL && window.location.hash.match(/#tab-(\d+)/)) {
      openTabByPosition();
    }
  });
}

// Help drawer anchoring
function initHelpDrawerAnchoring() {
  let lastProcessedDrawerHash = '';
  let isProcessingDrawerHash = false;

  function openHelpDrawerFromHash() {
    const hash = window.location.hash;
    
    // Only process help-drawer hash
    if (hash !== "#help-drawer") {
      return;
    }
    
    // Prevent processing the same hash multiple times
    if (hash === lastProcessedDrawerHash || isProcessingDrawerHash) {
      return;
    }
    
    isProcessingDrawerHash = true;
    lastProcessedDrawerHash = hash;
    
    const primaryTrigger = document.querySelector('a[aria-controls="HelpDrawer"]');

    if (primaryTrigger) {
      setTimeout(() => {
        primaryTrigger.click();
        
        // Reset processing flag after action completes
        setTimeout(() => {
          isProcessingDrawerHash = false;
        }, 500);
      }, 100);
    } else {
      isProcessingDrawerHash = false;
    }
  }

  // Handle clicks on help drawer links
  document.querySelectorAll('a[href="#help-drawer"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Set the hash first
      history.pushState(null, null, "#help-drawer");
      
      // Then trigger the drawer
      const primaryTrigger = document.querySelector('a[aria-controls="HelpDrawer"]');
      if (primaryTrigger) {
        primaryTrigger.click();
      }
    });
  });

  // Only run on initial page load if hash is help-drawer
  if (window.location.hash === "#help-drawer") {
    setTimeout(() => {
      openHelpDrawerFromHash();
    }, 200);
  }

  // Listen for hash changes
  window.addEventListener("hashchange", (e) => {
    // Only process if the hash actually changed and is help-drawer
    if (e.newURL !== e.oldURL && window.location.hash === "#help-drawer") {
      openHelpDrawerFromHash();
    }
  });
}

// NEW: General section anchoring functionality
function initSectionAnchoring() {
  let lastProcessedSectionHash = '';
  let isProcessingSectionHash = false;

  function scrollToSection() {
    const hash = window.location.hash;
    
    // Skip if no hash or if it's a special anchor (tab or help-drawer)
    if (!hash || hash.match(/#tab-(\d+)/) || hash === "#help-drawer") {
      return;
    }
    
    // Prevent processing the same hash multiple times
    if (hash === lastProcessedSectionHash || isProcessingSectionHash) {
      return;
    }
    
    // Remove the # to get the element ID
    const targetId = hash.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      isProcessingSectionHash = true;
      lastProcessedSectionHash = hash;
      
      // Scroll to the target element
      setTimeout(() => {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
        
        // Reset processing flag after scroll completes
        setTimeout(() => {
          isProcessingSectionHash = false;
        }, 1000);
      }, 100);
    } else {
      // Reset if element not found
      lastProcessedSectionHash = '';
      isProcessingSectionHash = false;
    }
  }

  // Handle clicks on section anchor links
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    
    // Skip special anchors (tabs and help-drawer)
    if (href.match(/#tab-(\d+)/) || href === "#help-drawer") {
      return;
    }
    
    // Check if target element exists
    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      e.preventDefault();
      e.stopPropagation();
      
      // Update URL hash
      history.pushState(null, null, href);
      
      // Scroll to target
      setTimeout(() => {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 50);
    }
  });

  // Run on initial page load if hash exists and matches a section
  if (window.location.hash && 
      !window.location.hash.match(/#tab-(\d+)/) && 
      window.location.hash !== "#help-drawer") {
    setTimeout(() => {
      scrollToSection();
    }, 200);
  }

  // Listen for hash changes
  window.addEventListener("hashchange", (e) => {
    // Only process if the hash actually changed and it's not a special anchor
    if (e.newURL !== e.oldURL && 
        !window.location.hash.match(/#tab-(\d+)/) && 
        window.location.hash !== "#help-drawer") {
      scrollToSection();
    }
  });
}

// Initialize all anchoring functionality when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Wait for other initializers to complete
  setTimeout(() => {
    initTabAnchoring();
    initHelpDrawerAnchoring();
    initSectionAnchoring(); // NEW: Initialize section anchoring
  }, 100);
});


// Variant filtraton system
class VariantFilterManager {
  constructor() {
    this.activeFilters = new Map();
    this.filterConfigs = new Map();
    this.init();
  }

  init() {
    this.addAntiFlashCSS();
    this.setupHTMLInterception();
    this.setupEventListeners();
    this.initializeFilters();
  }

  /**
   * Finds all disabled variant inputs/options within a container,
   * removes the 'disabled' attribute, adds a '.unavailable' class,
   * and appends text to dropdown options.
   * @param {HTMLElement} containerElement The element to search within.
   */
  enableUnavailableSwatches(containerElement) {
    if (!containerElement) return;

    const disabledSelectors = containerElement.querySelectorAll(
      'input:disabled, option:disabled'
    );

    disabledSelectors.forEach((selector) => {
      selector.removeAttribute('disabled');
      selector.classList.add('unavailable');

    });
  }

  addAntiFlashCSS() {
    if (document.getElementById('variant-filter-styles')) return;

    const style = document.createElement('style');
    style.id = 'variant-filter-styles';
    style.textContent = `
      .variant-picker.updating .filter-btn {
        visibility: hidden !important;
      }
      .variant-picker.updating * {
        transition: none !important;
      }
      .filter-btn {
        transition: all 0.05s ease;
      }
    `;
    document.head.appendChild(style);
  }

  setupEventListeners() {
    if (typeof theme !== 'undefined' && theme.pubsub) {
      theme.pubsub.subscribe(
        theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
        (event) => {
          const variantPicker = event.data.target.closest(
            '[id^="VariantPicker-"]'
          );
          if (variantPicker && this.hasFilterButtons(variantPicker)) {
            this.markAsUpdating(variantPicker);
          }
        }
      );
    }
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => this.initializeFilters(), 100);
    });
  }

  setupHTMLInterception() {
    if (typeof theme === 'undefined' || !theme.HTMLUpdateUtility) return;

    const originalViewTransition = theme.HTMLUpdateUtility.viewTransition;

    theme.HTMLUpdateUtility.viewTransition = (
      targetElement,
      sourceElement,
      preProcessCallbacks
    ) => {
      this.enableUnavailableSwatches(sourceElement);

      if (
        targetElement.id &&
        targetElement.id.startsWith('VariantPicker-') &&
        this.hasFilterButtons(sourceElement)
      ) {
        this.preserveFilterState(targetElement.id, sourceElement);
      }

      const result = originalViewTransition.call(
        theme.HTMLUpdateUtility,
        targetElement,
        sourceElement,
        preProcessCallbacks
      );

      if (targetElement.id && targetElement.id.startsWith('VariantPicker-')) {
        requestAnimationFrame(() => this.initializeFilters());
      }

      return result;
    };
  }

  hasFilterButtons(element) {
    return element.querySelectorAll('.filter-btn').length > 0;
  }

  initializeFilters() {
    const variantPickers = document.querySelectorAll('[id^="VariantPicker-"]');

    variantPickers.forEach((picker) => {
      this.enableUnavailableSwatches(picker);

      const pickerId = picker.id;
      const filterButtons = picker.querySelectorAll('.filter-btn');

      if (filterButtons.length === 0) return;

      const filterKey = picker.dataset.filterKey || 'color_temperature';

      const availableFilters = Array.from(filterButtons)
        .map((btn) => btn.dataset.filter)
        .filter((filter) => filter !== 'all');

      this.filterConfigs.set(pickerId, {
        filterKey,
        availableFilters,
      });

      filterButtons.forEach((button) => {
        button.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();

          const filter = button.dataset.filter;
          this.activeFilters.set(pickerId, filter);
          this.applyFilter(pickerId, filter);

          return false;
        };
      });

      const currentFilter = this.activeFilters.get(pickerId) || 'all';
      this.applyFilter(pickerId, currentFilter);
    });
  }

  applyFilter(pickerId, filter) {
    const variantPicker = document.getElementById(pickerId);
    if (!variantPicker) return;

    const filterButtons = variantPicker.querySelectorAll('.filter-btn');
    const swatchItems = variantPicker.querySelectorAll(
      '.swatch-item.filterable-swatch'
    );

    filterButtons.forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.filter === filter);
    });

    swatchItems.forEach((item) => {
      const itemFilterValues = (
        item.dataset.filterValues || 'neutral'
      ).toLowerCase();
      const filterLower = filter.toLowerCase();

      let shouldShow = false;

      if (filter === 'all') {
        shouldShow = true;
      } else {
        const variantFilters = itemFilterValues.split(',').map((f) => f.trim());
        shouldShow = variantFilters.includes(filterLower);
      }

      item.style.display = shouldShow ? '' : 'none';
      item.style.visibility = shouldShow ? 'visible' : 'hidden';
    });
  }

  preserveFilterState(pickerId, sourceElement) {
    const currentFilter = this.activeFilters.get(pickerId) || 'all';

    if (currentFilter !== 'all') {
      const filterButtons = sourceElement.querySelectorAll('.filter-btn');
      const swatchItems = sourceElement.querySelectorAll(
        '.swatch-item.filterable-swatch'
      );

      filterButtons.forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.filter === currentFilter);
      });

      swatchItems.forEach((item) => {
        const itemFilterValues = (
          item.dataset.filterValues || 'neutral'
        ).toLowerCase();
        const filterLower = currentFilter.toLowerCase();

        let shouldShow = false;
        if (currentFilter === 'all') {
          shouldShow = true;
        } else {
          const variantFilters = itemFilterValues.split(',').map((f) => f.trim());
          shouldShow = variantFilters.includes(filterLower);
        }

        if (!shouldShow) {
          item.style.display = 'none';
          item.style.visibility = 'hidden';
        }
      });
    }
  }

  markAsUpdating(variantPicker) {
    variantPicker.classList.add('updating');
    setTimeout(() => {
      variantPicker.classList.remove('updating');
    }, 200);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.variantFilterManager = new VariantFilterManager();
});

